// Legacy "Booking System" template leftover. The original `HTTP` axios client
// this file exported was a dead, hardcoded `http://localhost:3000` instance:
// it never went through the real §4 seam (`api/vivo/http.ts`), carried no
// bearer token wiring compatible with it, and its only consumers were
// `components/selector.vue` (itself unused by any route — deleted) and
// `helper.ts` (which only ever needed the `baseUploadURL` string below, not
// the axios instance). Removed to stop it from being a live, auth-bypassing
// network seam. `baseURL`/`baseUploadURL` are kept only as the string prefix
// `helper.ts`'s `$baseUploadURL` still uses to build uploaded-avatar URLs.
export const baseURL = "http://localhost:3000";
export const baseUploadURL = baseURL + "/uploads/";
